/**
* Shop JS
* -----------------------------------------------------------------------------
*
* All the JS for the Shop component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'shop',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( window.innerWidth >= 1024 ) {
        const bsDiv = document.getElementById( 'glow-cursor' );
        const shop = document.getElementById( 'shop-wrap' );
        let x; let y;
        shop.addEventListener( 'mouseenter', function( event ) {
          bsDiv.style.opacity = '100%';
        } );
        shop.addEventListener( 'mouseleave', function( event ) {
          bsDiv.style.opacity = '0';
        } );

        shop.addEventListener( 'mousemove', function( event ) {
          setTimeout( function() {
            x = event.clientX;
            y = event.clientY;
            if ( typeof x !== 'undefined' ) {
              bsDiv.style.left = x + 'px';
              bsDiv.style.top = y + 'px';
            }
          }, 80 );
        }, false );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'shop', COMPONENT );
} )( app );
